export const isSubjectData = (
  d: any,
  selectedIdValueData: any,
  categoricalScale: any,
  subgroupScale: any,
  colorScale: any,
) => {
  return selectedIdValueData.some((subjectData: any) => {
    return (
      String(d.data[categoricalScale.dataMapping]) ===
        String(subjectData[categoricalScale?.dataMapping]) &&
      (String(d.subgroupKey) ===
        String(subjectData[subgroupScale?.dataMapping]) ||
        String(d.subgroupKey) === "none") &&
      (String(d.stackKey) === String(subjectData[colorScale?.dataMapping]) ||
        String(d.stackKey) === "none")
    );
  });
};
